/* Single – checklist extra's spiegelen naar hoofdformulier en total updaten */
import { updateTotal } from './priceTotal.js';

function getMainForm() {
  return (
    document.querySelector('.single-product form.variations_form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart') ||
    document.querySelector('.single-product form.cart')
  );
}

export function mount() {
  const formForChecklist = getMainForm();
  const fs = document.querySelector('.wk-xs-checklist');

  if (!(formForChecklist && fs)) return;

  fs.addEventListener('change', (e) => {
    if (!e.target.matches('input[name="wk_xs_ids[]"]')) return;
    updateTotal(formForChecklist);
  });

  function mirrorInputsIntoForm() {
    formForChecklist
      .querySelectorAll('input[name="wk_xs_ids[]"][data-mirrored], input[name="wk_xs_nonce"][data-mirrored]')
      .forEach((n) => n.remove());

    fs.querySelectorAll('input[name="wk_xs_ids[]"]:checked').forEach((cb) => {
      const h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'wk_xs_ids[]';
      h.value = cb.value;
      h.dataset.mirrored = '1';
      formForChecklist.appendChild(h);
    });

    const nonce = fs.querySelector('input[name="wk_xs_nonce"]');
    if (nonce) {
      const n = document.createElement('input');
      n.type = 'hidden';
      n.name = 'wk_xs_nonce';
      n.value = nonce.value;
      n.dataset.mirrored = '1';
      formForChecklist.appendChild(n);
    }
  }

  formForChecklist.addEventListener('submit', mirrorInputsIntoForm);
  formForChecklist.addEventListener('click', (e) => {
    const btn = e.target.closest('.single_add_to_cart_button');
    if (!btn) return;
    mirrorInputsIntoForm();
  });
}
